import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { ArrowLeftIcon, ArrowRightIcon } from '@eventbrite/marmalade';
import {
    connectSearchFooter,
    getPaginationData,
    Pagination,
    PaginationData,
    WithRouterProps,
} from '@eventbrite/search-utils';
import React, { useCallback } from 'react';
import { withRouter } from '../../../utils/router';
import { SearchPaginator } from '../../SearchFooterContainer/components';
import styles from './PaginationControls.module.scss';
interface PaginationControlsProps extends WithRouterProps {
    pagination: PaginationData;
}

interface PaginationCtonrolsReduxProps {
    handleGetPage: Function;
    isBotRequest: boolean;
    prevPageUrl: string;
    nextPageUrl: string;
    firstPageUrl: string;
    lastPageUrl: string;
}

export const PaginationControls: React.FunctionComponent<
    PaginationControlsProps & PaginationCtonrolsReduxProps
> = ({
    pagination,
    handleGetPage,
    isBotRequest,
    prevPageUrl,
    nextPageUrl,
    firstPageUrl,
    lastPageUrl,
}) => {
    const { currentPage, totalNumResults, isNextDisabled, pageCount } =
        getPaginationData(pagination);

    const handlePageSelect = useCallback(
        (pageNumber: number) => {
            if (HAS_WINDOW) {
                window.scrollTo(0, 0);
            }

            const nextPage = isBotRequest ? pageNumber + 1 : pageNumber;

            handleGetPage(nextPage);
        },
        [handleGetPage, isBotRequest],
    );

    if (isBotRequest) {
        return (
            <SearchPaginator
                currentPage={currentPage - 1}
                handleGetPage={handlePageSelect}
                isNextDisabled={isNextDisabled}
                nextUrl={nextPageUrl}
                prevUrl={prevPageUrl}
                firstPageUrl={firstPageUrl}
                lastPageUrl={lastPageUrl}
                pageCount={pageCount}
            />
        );
    }

    return (
        <div className={styles.paginationWrapper}>
            <Pagination
                pageNumber={currentPage}
                totalNumResults={totalNumResults}
                onSelected={handlePageSelect}
                prevIcon={
                    <div className={styles.paginationButton}>
                        <ArrowLeftIcon size="medium" />
                    </div>
                }
                nextIcon={
                    <div className={styles.paginationButton}>
                        <ArrowRightIcon size="medium" />
                    </div>
                }
            />
        </div>
    );
};

export default withRouter<PaginationControlsProps>(
    connectSearchFooter(PaginationControls),
);
